/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap'

import EditKeywordValueModal from './EditKeywordValueModal.js'
import { AppContext } from '../../AppContext.js';

class KeywordsAndValues extends React.Component {

  columnWidths = {};
  debouncedSaveColumnWidths = null;

  closeKeywordValueModal() 
  {
    this.setState({ modalIsOpen: false });
  }

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.props.valueColumnKey);
  }

  constructor(props) 
  {
    super();

    let columns =
      [
        { id: 'keyword', accessor: 'keyword', Header: 'Keyword Group / Keyword', show: true,
            Cell: rowInfo => <div><span title={'Keyword Group: ' + rowInfo.row.keywordGroup}>{rowInfo.row.keywordGroup + ' / ' + rowInfo.value}</span></div>},
        { accessor: 'keywordValueType', Header: '', show: false },
        { id: 'displayedValue', accessor: rowInfo => { return this.formatKeywordValueType(rowInfo) }, Header: 'Keyword Value', show: true,
            Cell: rowInfo => <div><span title={'Keyword Group: ' + rowInfo.row.keywordGroup}>{rowInfo.value}</span></div>},
        { accessor: 'keywordId', show: false },
        { accessor: 'userInputHandling', show: false },
        { accessor: 'valueId', show: false },
        { accessor: 'characterValue', show: false},
        { accessor: 'integerValue', show: false},
        { accessor: 'floatingPointValue', show: false},
        { accessor: 'dateValue', show: false},
        { accessor: 'timestampValue', show: false},
        { accessor: 'keywordGroup', show: false}
      ]

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);

    this.state =
      {
        columns: columns,
        selectedRows: [],
        modalIsOpen: false,
        keywordAndValue: undefined
      }

    this.noDataText = props.selectedObjects.length > 1 ? 'No common keywords' : 'No keywords assigned';

    this.closeKeywordValueModal = this.closeKeywordValueModal.bind(this);
    this.editSelectedKeywordValue = this.editSelectedKeywordValue.bind(this);
    this.removeKeyword = this.removeKeyword.bind(this);
  }

  editKeywordValue(rowInfo) 
  {
    if ('undefined' !== typeof (rowInfo) && !this.props.immutableRowFound &&
      ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType))
      this.setState({ modalIsOpen: true, keywordAndValue: rowInfo.row });
  }

  editSelectedKeywordValue() 
  {
    if (this.state.selectedRows.length < 1) {
      this.context.postNotification('info', 'Please select a keyword first');
      return;
    }

    if (this.state.selectedRows.length > 1) {
      this.context.postNotification('info', 'Please select only one keyword');
      return;
    }

    this.setState({ modalIsOpen: true, keywordAndValue: this.props.keywordsAndValues[this.state.selectedRows[0]] });
  }

  formatKeywordValueType(rowInfo) 
  {
    if ('date' === rowInfo.keywordValueType)
      return null === rowInfo.valueId ? null : window.moment.unix(rowInfo.dateValue).utc().format('LL');

    if ('timestamp' === rowInfo.keywordValueType)
      return null === rowInfo.valueId ? null : window.moment.unix(rowInfo.timestampValue).utc().format('LL LTS');

    if ('time' === rowInfo.keywordValueType)
      return null === rowInfo.valueId ? null : window.moment.unix(rowInfo.timestampValue).utc().format('LTS');

    if ('integer' === rowInfo.keywordValueType) return rowInfo.integerValue;

    if ('floating point' === rowInfo.keywordValueType) return rowInfo.floatingPointValue;

    if ('json' === rowInfo.keywordValueType) return JSON.stringify(rowInfo.jsonValue);

    return rowInfo.characterValue;
  }

  removeKeyword(rowInfo) 
  {
    if (this.state.selectedRows.length < 1) 
    {
      this.context.postNotification('info', 'Please select a keyword first');
      return;
    }

    var bodyData = {};

    let objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) objectIds.push(this.props.selectedObjects[x].objectId);

    bodyData.objectIds = objectIds;

    let keywordValuePairs = [];
    for (let i = 0; i < this.state.selectedRows.length; i++) 
    {
      keywordValuePairs[i] = {};
      keywordValuePairs[i].keywordId = this.props.keywordsAndValues[this.state.selectedRows[i]].keywordId;
      keywordValuePairs[i].valueId = this.props.keywordsAndValues[this.state.selectedRows[i]].valueId;
    }

    bodyData.keywordValuePairs = keywordValuePairs;

    this.props.removeKeyword(bodyData);
    this.setState({ selectedRows: [] });
  }

  render() 
  {
    let editKeywordValueModal = null;

    let objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) objectIds.push(this.props.selectedObjects[x].objectId);

    if (this.state.modalIsOpen) 
    {
      editKeywordValueModal = (
        <EditKeywordValueModal
          objectIds={objectIds} closeModal={this.closeKeywordValueModal} modalIsOpen={this.state.modalIsOpen}
          keywordAndValue={this.state.keywordAndValue} viewType={this.props.viewType}
          refreshQueryValues={this.props.refreshQueryValues} refreshKeywordsAndValues={this.props.refreshKeywordsAndValues}
        />
      );
    }

    return (
      <div>
        {editKeywordValueModal}
        <ReactTable data={this.props.keywordsAndValues} showPagination={true} columns={this.state.columns} minRows={1} className="-highlight"
          noDataText={this.noDataText}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo === undefined) return {};
            let x = this.state.selectedRows.indexOf(rowInfo.index);
            if (-1 === x)
              return {}
            else
              return { style: { fontWeight: "bold", color: "#ffffff", backgroundColor: "#0275d8" } } // #0275d8 matches reactstrap, #00abc7 matches uploader theme
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => { this.selectionHandler(e, handleOriginal, rowInfo, column, instance) },
              onDoubleClick: this.editKeywordValue.bind(this, rowInfo),
            }
          }}
          onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)}
        />
        {(!this.props.immutableRowFound && ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType)) &&
          <ButtonToolbar>
            <ButtonGroup size="sm" style={{ marginLeft: 'auto' }} >
              <Button color="transparent" title="Edit keyword" onClick={this.editSelectedKeywordValue}><img src="assets/images/pencil.png" alt="Edit keyword" /></Button>
              <Button color="transparent" title="Remove keyword(s)" onClick={this.removeKeyword}><img src="assets/images/trash.png" alt="Remove keyword(s)" /></Button>
            </ButtonGroup>
          </ButtonToolbar>
        }

      </div>
    );
  }

  saveColumnWidths(resizedColumns) 
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.props.valueColumnKey);
  }

  selectionHandler(event, handleOriginal, rowInfo, column, instance) 
  {
    if (typeof rowInfo === 'undefined')
      return;

    if (event.shiftKey) 
    {
      let max = Math.max(rowInfo.index, Math.max.apply(Math, this.state.selectedRows));
      let min = Math.min(rowInfo.index, Math.min.apply(Math, this.state.selectedRows));
      let selectedRows = [];
      for (let i = min; i <= max; i++)
        selectedRows.push(i);
      this.setState({ selectedRows: selectedRows });
    }
    else if (event.ctrlKey) 
    {
      let x = this.state.selectedRows.indexOf(rowInfo.index);
      if (-1 === x) 
      {
        let selectedRows = this.state.selectedRows;
        selectedRows.push(rowInfo.index);
        this.setState({ selectedRows: selectedRows });
      }
      else 
      {
        let selectedRows = this.state.selectedRows;
        selectedRows.splice(x, 1);
        this.setState({ selectedRows: selectedRows });
      }
    }
    else 
    {
      let selectedRows = [];
      selectedRows.push(rowInfo.index);
      this.setState({ selectedRows: selectedRows });
    }

    window.clearTextSelection();
  }
}

KeywordsAndValues.contextType = AppContext;

export default KeywordsAndValues
